const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = "lazy";
  return newImage;
};

const checkSwatches = () => {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      // use 'change' to support keyboard interaction too
      input.addEventListener("change", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (!event.currentTarget.checked) return;

        const swatchLink = wrapper.querySelector(".js-color-swatches-link");
        if (swatchLink) {
          swatchLink.setAttribute("href", event.currentTarget.dataset.variantLink);
        }

        const currentColor = event.currentTarget.value;

        jQuery.getJSON(
          window.Shopify.routes.root + `products/${handleProduct}.js`,
          function (product) {
            const variant = product.variants.find(
              (item) => item.featured_media != null && item.options.includes(currentColor)
            );

            if (!variant) return;

            // gather ids used by data-media-id in Liquid:
            // `${product.id}-${section.id}-${img.id}`
            const sectionId = wrapper.dataset.section || "default-section";
            const mediaId = variant.featured_media.id;
            if (!sectionId || !mediaId) return;

            const mediaIdString = `${product.id}-${sectionId}-${mediaId}`;

            const swiperWrappers = wrapper.querySelectorAll(".global-variant-slider");

            swiperWrappers.forEach((elem) => {
              if (elem.classList.contains("hidden")) return;

              // The Swiper instance is attached to the container element itself
              const mediaList = elem;

              if (mediaList?.swiper) {
                // scope slide search to THIS container only
                const targetSlide = mediaList.querySelector(`[data-media-id="${mediaIdString}"]`);
                if (!targetSlide) return;

                const sw = mediaList.swiper;

                const allSlidesArr = Array.from(sw.slides || []);
                const baseSlides = allSlidesArr.filter(
                  (s) => !s.classList.contains("swiper-slide-duplicate")
                );

                // Prefer real (non-duplicate) index by matching dataset
                let realIndex = baseSlides.findIndex(
                  (s) => s.dataset.mediaId === mediaIdString
                );

                // Fallback: use Swiper's duplicate index mapping when loop is on
                if (realIndex === -1) {
                  const loopIndexAttr = targetSlide.getAttribute("data-swiper-slide-index");
                  if (loopIndexAttr != null) {
                    realIndex = parseInt(loopIndexAttr, 10);
                  } else {
                    // Last fallback: direct match in all slides
                    realIndex = allSlidesArr.findIndex((s) => s === targetSlide);
                    if (realIndex < 0) return;
                  }
                }

                // Move to the correct slide (loop-aware)
                if (sw.params && sw.params.loop && typeof sw.slideToLoop === "function") {
                  sw.slideToLoop(realIndex);
                } else {
                  sw.slideTo(realIndex);
                }
              } else {
                // ---- Non-slider fallback: swap images as before ----
                if (!variant) return;

                if (!primaryImage) return;

                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let promoted = false;

                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname === newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      promoted = true;
                    }
                  }

                  if (!promoted) {
                    primaryImage
                      .animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" })
                      .finished;
                    setTimeout(function () {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate(
                        { opacity: [0, 1] },
                        { duration: 200, easing: "ease-in" }
                      );
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        );
      });
    });
  });
};

function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();